<template>
  <div class="create-hub">
    <HubForm mode="create" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    HubForm: () => import(/* webpackChunkName: "HubForm" */ '@/views/Hub/HubForm')
  }
}
</script>
